var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('p',{staticClass:"lowest-price"},[_vm._v(" "+_vm._s(_vm.caption)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }